// extracted by mini-css-extract-plugin
module.exports = {"nav-brand":"styles_nav-brand__2lvlX"};